import {createSlice} from "@reduxjs/toolkit";
import {ExternalLinksAPI} from "../../app/externalLinksApi";

export const externalLinksSlice = createSlice({
    name: "externalLinks",
    initialState: {
        noContextLinks: [],
        contextLinks: []
    },
    reducers: {
        setExternalLinks: (state, linksData) => {
            linksData.payload.forEach(link => {
              if(link.linkType == "noContext" || link.linkType == "Agyle_noContext" ){
                  state.noContextLinks.push(link);
              } else {
                  state.contextLinks.push(link);
              }
            })

        }
    }
});
export const {setExternalLinks} = externalLinksSlice.actions;

export const simpleLinks = state => state.externalLinks.noContextLinks;
export const contextLinks = state => state.externalLinks.contextLinks;

export const loadExternalLinks = () => (dispatch) => {
    ExternalLinksAPI.getExternalLinks().then(externalLinks => {
        dispatch(setExternalLinks(externalLinks));
        }).catch(function (error) {
            console.error(error);
        });
    };

export default externalLinksSlice.reducer;
